<template>
	<button
			:class="[customClass, {'extended': isExtended}, {'allElements': isAllElements}]"
			:style="{ width, height, margin }"
			type="button"
			class="customBtn"
			:disabled="isDisabled"
			@click="onClick">
		<v-progress-circular
				class="progressIcon"
				v-if="isPreloader"
				size="20"
				indeterminate
				color="green"
		></v-progress-circular>
		<template v-if="isAllElements">
			<svg-sprite v-bind="iconAttrs"></svg-sprite>
			<span>{{ text }}</span>
		</template>
		<template v-else >
			<svg-sprite v-if="iconAttrs" v-bind="iconAttrs"></svg-sprite>
			<span v-else>{{ text }}</span>
		</template>
	</button>
</template>

<script>
export default {
	name: "CustomBtn",
	props: {
		text: String,
		customClass: String,
		isAllElements: Boolean,
		isPreloader: Boolean,
		isDisabled: Boolean,
		isExtended: Boolean,
		iconAttrs: Object,
		width: {
			type: String,
			default: '145px'
		},
		margin: {
			type: String,
			default: '5px'
		},
		height: {
			type: String,
			default: '36px'
		},
	},
	methods: {
		onClick() {
			this.$emit('updateEvent');
		}
	}
};
</script>

<style scoped lang="scss">
@import "CustomBtn";

</style>
